import React, { useState } from 'react'
import { FaBars, FaTimes } from 'react-icons/fa';
import { Link } from 'react-router-dom'


const Header = () => {

   

    const handleClick = () => {
        window.scrollTo(0, 0); // Scrolls to the top of the page
    };

    const scrollToDiv1 = () => {
        const element = document.getElementById("headerPostAppGaraFashion");
        if (element) {
          element.scrollIntoView({ behavior: "smooth" }); // Smooth scrolling to the element
        }
      };

    const scrollToDiv2 = () => {
        const element = document.getElementById("product2");
        if (element) {
            element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };
    const scrollToDiv3 = () => {
        const element = document.getElementById("product3");
        if (element) {
            element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };

    const scrollToDiv4 = () => {
        const element = document.getElementById("headerPostAppGaraAuto");
        if (element) {
          element.scrollIntoView({ behavior: "smooth" }); // Smooth scrolling to the element
        }
      };


    const [isMenuOpen, setIsMenuOpen] = useState(false); // State to track menu visibility

    const [showList, setShowList] = useState(false);
    const [showList2, setShowList2] = useState(false);
   

  return (
    <div>
       <div className='navbar'>
           <div className='navLogo'>
            <h1 id='logoName' onClick={handleClick}>
            <Link to="/">Gara-Innov</Link>
                </h1>
           </div>

           <div className='navbar1'>
           <div>
            <div>
            <h4 id='navBarText'
           onClick={()=>{
            setShowList(!showList)
            
           }}
            >
               
                Produits
              
               
                </h4>

               
                </div>

               
           </div>
           <div>
            <h4 id='navBarText'>
            <a href="#product2" onClick={scrollToDiv2} style={{ textDecoration: "none", color: "inherit" }}>
            À propos
                </a>
                </h4>
           </div>
           <div>
            <h4 id='navBarText'>
            <a href="#product3" onClick={scrollToDiv3} style={{ textDecoration: "none", color: "inherit" }}>
            Équipe
                </a>
                </h4>
           </div>

           <div className='menu'>
           {isMenuOpen ? (
            
          <FaTimes id='menuBarClose' size="2em"
            onClick={
                ()=>{
                    setIsMenuOpen(false);
                }
            }
           />
          ):(
            <FaBars id='menuBar' size="2em"
            onClick={
                ()=>{
                    setIsMenuOpen(true);
                   
                }
            }
          />
            
          )}


           </div>

           </div>

          
     
       </div>


      

       {/* MENU BAR  */}

       <div>
        {isMenuOpen ?(
            <div className='menuOpen'>
               <ul>
               <div>
                <li>
               <h4 id='navBarTextMenu'
                onClick={()=>{
                    setShowList2(!showList2)
                   }}
               
               >
                Produits
               
                </h4>
                </li>

                {showList2 &&(
                    <>
                  
                    <li id='productD2'>
                    <a
                        href="#headerPostAppGaraFashion"
                        onClick={(e) => {
                            e.preventDefault(); // Prevent default anchor tag behavior
                            scrollToDiv1(); // Call your custom scrolling logic
                            setShowList2(!showList2);
                            setIsMenuOpen(false);
                        }}
                        >
                        Gara-Fashion
                        </a>
                     </li> 

                    <li id='productD2'>
                    <a
                        href="#headerPostAppGaraAuto"
                        onClick={(e) => {
                            e.preventDefault(); // Prevent default anchor tag behavior
                            scrollToDiv4(); // Call your custom scrolling logic
                            setShowList2(!showList2);
                            setIsMenuOpen(false);
                        }}
                        >
                        Gara-Auto
                        </a>
                     </li> 
                       </>
                    
                  
                )}
                </div>

                <li>
                <h4 id='navBarTextMenu'>
            <a href="#product2" onClick={()=>{
                    setIsMenuOpen(false);
                    scrollToDiv2()
                
                }} style={{ textDecoration: "none", color: "inherit" }}>
            À propos
                </a>
                </h4>
                </li>

                <li>
                 <h4 id='navBarTextMenu'>
            <a href="#product3" onClick={()=>{
                    setIsMenuOpen(false);
                    scrollToDiv3()
                
                }} style={{ textDecoration: "none", color: "inherit" }}>
            Équipe
                </a>
                </h4>
                </li>

               </ul>
                </div>
        ):null}
       </div>


          {/* List displayed on hover */}
          <div className='headerUl'>
                {showList && (
        <ul>
          <li id='productD'>
          <a href="#headerPostAppGaraFashion"
          onClick={()=>{
            setShowList(!showList);
            scrollToDiv1();
            setIsMenuOpen(false);
            
          }}
          >Gara-Fashion</a>
           </li> 

          <li id='productD'>
          <a href="#headerPostAppGaraAuto"
          onClick={()=>{
            setShowList(!showList);
            scrollToDiv4();
            setIsMenuOpen(false);
            
          }}
          >Gara-Auto</a>
           </li> 
        </ul>
      )}
                </div>
      

       <div className='promoVidContainer'>
       <video autoPlay loop muted className="background-video">
        <source src="/bg.mp4" type="video/mp4" />
        Votre navigateur ne prend pas en charge la balise vidéo.
      </video>
      <div className="overlay-content">
        <h1 id='catchyText'>Stimuler l'Innovation, Façonner l'Avenir de l'Afrique</h1>
      </div>
       </div>
      
    </div>
  )
}

export default Header
